import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BankStatementCollectionUI from './BankStatementCollectionUI.js'
import { RichUtils } from 'draft-js'
import { ResponsiveContainer } from 'recharts'

class BankStatementCollectionSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // download files
      downloadRequested: false,
      fileErrorList: null,
      // re-upload bank statements
      // bsErrorList: null,
      // bsSuccessMsg: null,
      // bsSubmitted: false,

      reuploadSubmitted: false,
      reuploadSuccessMsg: null,
      reuploadErrorList: [],
      reuploadType: null,
      reuploadEnabled: false,

      // bank stmt upload
      bsUploadMode: false,
      bsUploadErrorList: [],
      //
      updateDateMode: false,
      deleteSubmitted: false,

      selectedFolder: null,
    }
  }

  render() {
    return (
      <BankStatementCollectionUI
        context={this.props.context}
        account={this.props.account}
        bankAccountList={this.props.bankAccountList}
        onRefreshClick={this.props.onRefreshClick}
        onCopyToClipboard={this.props.onCopyToClipboard}
        copyToClipboardText={this.props.copyToClipboardText}
        //
        onDownloadFileClick={this.onDownloadFileClick}
        fileErrorList={this.state.fileErrorList}
        // bank stmt
        // bsErrorList={this.state.bsErrorList}
        // bsSuccessMsg={this.state.bsSuccessMsg}
        // bsSubmitted={this.state.bsSubmitted}
        bsFileList={this.props.bsFileList}
        // onBSSubmit={this.onBSSubmit}
        onEnableReuploadClick={() => this.onReuploadClick(false)}
        onDeleteAndReuploadClick={() => this.onReuploadClick(true)}
        reuploadSubmitted={this.state.reuploadSubmitted}
        reuploadSuccessMsg={this.state.reuploadSuccessMsg}
        reuploadErrorList={this.state.reuploadErrorList}
        reuploadType={this.state.reuploadType}
        reuploadEnabled={this.state.reuploadEnabled}
        // bank stmt upload
        bsUploadMode={this.state.bsUploadMode}
        onBSUploadClick={() => { this.setState({ bsUploadMode: true }) }}
        onBSCancelUploadClick={() => { this.setState({ bsUploadMode: false }) }}
        bsSignedUrlApi={`/api/su/accounts/${this.props.account.accountId}/bankStatements/fileUploadSignedUrl`}
        onBSUpload={this.onBSUpload}
        bsUploadErrorList={this.state.bsUploadErrorList}
        // To submit to Np
        npErrorList={this.state.npErrorList}
        npSuccessMsg={this.state.npSuccessMsg}
        npSubmitted={this.state.npSubmitted}
        npFileList={this.props.npFileList}
        onNPSubmit={this.onNPSubmit}
        setNPErrorList={() => { }}
        // creditAssessmentDate modal
        updateDateMode={this.state.updateDateMode}
        onUpdateDateClick={() => { this.setState({ updateDateMode: true }) }}
        onCancelDateClick={() => { this.setState({ updateDateMode: false }) }}
        onAccountUpdate={this.props.onAccountUpdate}

        //
        onDeleteClick={this.onDeleteClick}
        onDeleteClickCallback={this.onDeleteClickCallback}
        deleteSubmitted={this.state.deleteSubmitted}
        //SelectedFolder
        selectedFolder={this.state.selectedFolder}
        onViewFolderClick={this.onViewFolderClick}
        clientTxnsReuploadErrorList={this.state.clientTxnsReuploadErrorList}
        clientTxnsReuploadSuccessMsg={this.state.clientTxnsReuploadSuccessMsg}
        clientTxnsReuploadSubmitted={this.state.clientTxnsReuploadSubmitted}
        onClientTxnsReuploadClick={this.onClientTxnsReuploadClick}
        //
        onDeleteTxnClick={this.onDeleteTxnClick}
        deleteSubmitted={this.state.deleteSubmitted}
      />
    )
  }

  componentDidMount = () => {
    this.setState({
      selectedFolder: this.props.account.documentStatus.creditAssessmentDocId
    })
  }

  // onBSSubmit = () => {
  //   let bsSubmitted = this.state.bsSubmitted
  //   if (bsSubmitted)
  //     return

  //   this.setState({
  //     bsSuccessMsg: null,
  //     bsErrorList: [],
  //     bsSubmitted: true
  //   })

  //   RestApiUtils.put(this.props.context,
  //     `/api/su/accounts/${this.props.account.accountId}/bankStatements/enableReupload`,
  //     this.onBSSubmitCallback, {}
  //   )
  // }
  onReuploadClick = (deleteFlag) => {
    if (this.state.reuploadSubmitted)
      return

    this.setState({
      reuploadSubmitted: true,
      reuploadSuccessMsg: null,
      reuploadErrorList: [],
      reuploadType: deleteFlag ? 'delete' : 'enable'
    })
    RestApiUtils.put(
      this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/bankStatements/enableReupload?deleteRequired=${deleteFlag}`,
      this.onReuploadCallback,
      {}
    )
  }
  onReuploadCallback = (response) => {
    let errorList = response.errorList.map(e => e.message)
    const isEnableAction = this.state.reuploadType === 'enable'

    this.setState({
      reuploadSubmitted: false,
      reuploadSuccessMsg: response.success,
      reuploadErrorList: errorList,
      reuploadEnabled:
        isEnableAction && response.errorList.length === 0
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ reuploadSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    } else {
      setTimeout(() => {
        this.setState({ reuploadErrorList: [] })
      }, 5000)
    }
  }

  onNPSubmit = () => {
    let npSubmitted = this.state.npSubmitted
    if (npSubmitted)
      return

    this.setState({
      npSuccessMsg: null,
      npErrorList: [],
      npSubmitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/creditAssesments/novelPatterns`,
      this.onNPSubmitCallback, {}
    )
  }
  onNPSubmitCallback = (response) => {
    let npErrorList = []
    response.errorList.forEach(error => {
      npErrorList.push(error.message)
    })

    this.setState({
      npSuccessMsg: response.success,
      npErrorList: npErrorList,
      npSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ npSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ npErrorList: [] })
      }, 30000)
    }
  }

  setNPErrorList = (npErrorList) => {
    this.setState({ npErrorList: npErrorList })
  }

  onBSSubmitCallback = (response) => {
    let bsErrorList = []
    response.errorList.forEach(error => {
      bsErrorList.push(error.message)
    })

    this.setState({
      bsSuccessMsg: response.success,
      bsErrorList: bsErrorList,
      bsSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ bsSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ bsErrorList: [] })
      }, 5000)
    }

  }

  onDownloadFileClick = (event) => {
    let fileType = event.currentTarget.getAttribute('data-type')
    let fileName = event.currentTarget.getAttribute('data-file-name')
    let folder = event.currentTarget.getAttribute("data-folder")

    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/companyReports/files/${fileType}/${fileName}/fileDownloadSignedUrl?folder=${folder}`,
      this.onDownloadFileClickCallback, null, null
    )
  }

  onDeleteClick = (event) => {
    let fileName = event.currentTarget.getAttribute('data-file-name')
    let folder = event.currentTarget.getAttribute('data-folder')

    RestApiUtils.delete(
      this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/bankStatements/files/${fileName}?folder=${folder}`,
      this.onDeleteClickCallback,
      null,
      null
    )
  }

  onDeleteClickCallback = response => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onDownloadFileClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      // const link = document.createElement('a')
      // link.href = response.signedUrl.signedUrl
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      window.open(response.signedUrl.signedUrl, '_blank')
    }
  }

  onBSUpload = (fileId, fileName, fileType, fileSize) => {
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/bankStatements/validation`,
      this.onBSUploadCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onBSUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      bsUploadErrorList: errorList,
    })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onViewFolderClick = (folder) => {
    this.setState({
      selectedFolder: this.state.selectedFolder === folder ? null : folder
    })
  }

  onUpdateDateClick = () => {
    this.setState({ updateDateMode: true })
  }

  onCancelDateClick = () => {
    this.setState({ updateDateMode: false })
  }
  onClientTxnsReuploadClick = () => {
    let clientTxnsReuploadSubmitted = this.state.clientTxnsReuploadSubmitted
    if (clientTxnsReuploadSubmitted)
      return

    this.setState({
      clientTxnsReuploadSuccessMsg: null,
      clientTxnsReuploadErrorList: [],
      clientTxnsReuploadSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/s3/novelPatterns/clientTransactions`,
      this.onClientTxnsReuploadClickCallback, {}
    )
  }

  onClientTxnsReuploadClickCallback = (response) => {
    if (!response || !response.errorList) {
      this.setState({
        clientTxnsReuploadSubmitted: false
      })
    }

    let clientTxnsReuploadErrorList = []
    response.errorList.forEach(error => {
      clientTxnsReuploadErrorList.push(error.message)
    })

    this.setState({
      clientTxnsReuploadSuccessMsg: response.success,
      clientTxnsReuploadErrorList: clientTxnsReuploadErrorList,
      clientTxnsReuploadSubmitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({ clientTxnsReuploadSuccessMsg: null })
        this.props.onRefreshClick()
      }, 3000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ clientTxnsReuploadErrorList: [] })
      }, 5000)
    }
  }

  onDeleteTxnClick = () => {
    if (this.state.deleteSubmitted)
      return

    this.setState({ deleteSubmitted: true })
    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/clientTransactions`,
      this.onDeleteClickCallback, null, null
    )
  }

  onDeleteClickCallback = response => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

}

export default BankStatementCollectionSF
